import { Injectable } from '@angular/core';
import { Actions as EffectActions, createEffect, ofType } from '@ngrx/effects';
import { ActionType } from './store/actions/products.actions';
import { Observable, of, throwError } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import * as Actions from './store/actions/products.actions';
import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Product } from './product.model';
import { ProductsService } from './products.service';

@Injectable({
  providedIn: 'root'
})
export class ProductsEffects {

  url = 'https://localhost:44358';

  constructor(
    private actions$: EffectActions,
    private http: HttpClient,
    private productsService: ProductsService
  ) { }


  
  fetchProductsRequest = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.FETCH_PRODUCTS),
      mergeMap((action: Actions.FetchProducts) => {

        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

        return this.http.get<Product[]>(this.url + '/api/Products', httpOptions)
          .pipe(
            mergeMap((response: any) => {
              return ([
                new Actions.FetchProductsSuccess(response)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.FetchProductsFailed(err));
            })

          );
      })
    ));

  // @Effect()
  // fetchProductsByCompanyIdRequest = this.actions$
  //   .pipe(
  //     ofType(ActionType.FETCH_PRODUCTS_BY_COMPANYID),
  //     mergeMap((action: Actions.FetchProductsByCompanyId) => {

  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.http.get<Product[]>(this.url + '/api/Products/GetProductsByCompanyId/' + action.companyId, httpOptions)

  //         .pipe(
  //           mergeMap((response: any) => {
  //             return ([
  //               new Actions.FetchProductsByCompanyIdSuccess(response)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.FetchProductsByCompanyIdFailed(err));
  //           })

  //         );
  //     })
  //   );

  
  fetchProductsByCompanyIdRequestFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.FETCH_PRODUCTS_BY_COMPANYID),
      mergeMap((action: Actions.FetchProductsByCompanyId) => {

        return this.productsService.getProductsByCompanyId$(action.companyId)
          .pipe(
            mergeMap((response: any) => {
              return ([
                new Actions.FetchProductsByCompanyIdSuccess(response)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.FetchProductsByCompanyIdFailed(err));
            })

          );
      })
    ));

  
  fetchProductsByCompanyIdSiteIdRequestFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.FETCH_PRODUCTS_BY_COMPANYIDSITEID),
      mergeMap((action: Actions.FetchProductsByCompanyIdSiteId) => {

        return this.productsService.getProductsByCompanyIdSiteId$(action.companyId, action.siteId)
          .pipe(
            mergeMap((response: any) => {
              return ([
                new Actions.FetchProductsByCompanyIdSiteIdSuccess(response)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.FetchProductsByCompanyIdSiteIdFailed(err));
            })

          );
      })
    ));

  
  addProductFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.ADD_PRODUCT),
      mergeMap(async (action: Actions.AddProduct) => {

        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

        const product = action.product;

        await this.productsService.addProductFirebase$(product)
          .then((response) => {
            product.id = response.id;
            console.log('product...', product);
          }).catch((err) => {
            // product.id = null;
            console.log('err in catch...', err);
          });

        if (product.id !== null) {
          return new Actions.AddProductSuccess(product);
        } else {
          return new Actions.AddProductFailed();
        }
      })
    ));

  
  updateProductFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.UPDATE_PRODUCT),
      mergeMap((action: Actions.UpdateProduct) => {

        const product = action.product;

        return this.productsService.updateProductFirebase$(product)
          .pipe(
            mergeMap((response: any) => {

              console.log('response updateProductFirebase...', product);
              return ([
                new Actions.UpdateProductSuccess(product.id!, product)
              ]);
            }
            ),
            catchError(err => {
              console.log('Handling error locally and rethrowing it...', err);
              return of(new Actions.UpdateProductFailed());
            })

          );
      })
    ));

  // @Effect()
  // deleteBug = this.actions$
  //   .pipe(
  //     ofType(ActionType.DELETE_PRODUCT),
  //     mergeMap((action: Actions.DeleteProduct) => {
  //       const id = action.id;
  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.http.delete<number>(this.url + '/api/Products/' + id, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {
  //             console.log('response...', response);
  //             return ([
  //               new Actions.DeleteProductSuccess(response.id)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.DeleteProductFailed());
  //           })

  //         );
  //     })
  //   );

  
  destroyChannelFirebase = createEffect(() => this.actions$
    .pipe(
      ofType(ActionType.DESTROY_PRODUCT),
      mergeMap(async (action: Actions.DestroyProduct) => {

        const id = action.id;

        await this.productsService.destroyProductFirebase$(id)
          .then((response) => {
            console.log('response...', response);
          }).catch((err) => {
            console.log('err in catch...', err);
          });

        if (id !== null) {
          return new Actions.DestroyProductSuccess(id);
        } else {
          return new Actions.DestroyProductFailed();
        }
      })
    ));

    
    deleteProductFirebase = createEffect(() => this.actions$
      .pipe(
        ofType(ActionType.DELETE_PRODUCT),
        mergeMap(async (action: Actions.DeleteProduct) => {

          const id = action.id;

          await this.productsService.deleteProductFirebase$(id)
            .then((response) => {
              console.log('response...', response);
            }).catch((err) => {
              console.log('err in catch...', err);
            });

          if (id !== null) {
            return new Actions.DeleteProductSuccess(id);
          } else {
            return new Actions.DeleteProductFailed();
          }
        })
      ));
  // @Effect()
  // destroyProduct = this.actions$
  //   .pipe(
  //     ofType(ActionType.DESTROY_PRODUCT),
  //     mergeMap((action: Actions.DestroyProduct) => {
  //       const id = action.id;
  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       return this.http.delete<number>(this.url + '/api/Products/' + id, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {
  //             console.log('response...', response);
  //             return ([
  //               new Actions.DestroyProductSuccess(response.id)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.DestroyProductFailed());
  //           })

  //         );
  //     })
  //   );

  // @Effect()
  // updateBug = this.actions$
  //   .pipe(
  //     ofType(ActionType.UPDATE_PRODUCT),
  //     mergeMap((action: Actions.UpdateProduct) => {

  //       const message = action.product;
  //       const id = action.product.id;
  //       const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  //       const bug = action.product;

  //       return this.http.put<Product>(this.url + '/api/Products/' + id, bug, httpOptions)
  //         .pipe(
  //           mergeMap((response: any) => {

  //             console.log('response updateBug...', bug);
  //             return ([
  //               new Actions.UpdateProductSuccess(bug)
  //             ]);
  //           }
  //           ),
  //           catchError(err => {
  //             console.log('Handling error locally and rethrowing it...', err);
  //             return of(new Actions.UpdateProductFailed());
  //           })

  //         );
  //     })
  //   );
}
